module.exports = __webpack_public_path__ + "img/_bookingcom.5e307498.svg";